import React from "react";

interface Props {
	children: React.ReactNode;
	className?: string;
}

const StickyFooter = ({ children, className }: Props) => {
	return (
		<footer className={`sticky-footer ${className ?? ""}`}>
			<div className="sticky-footer-container">{children}</div>
		</footer>
	);
};

export default StickyFooter;
